import gql from "graphql-tag";

export default gql`
  subscription SubscribeToSensorMeasurementChanges($id: Int!) {
    subscribeToSensorMeasurementChanges(id: $id)
  }
`;
